import React from 'react'
import styled from 'styled-components'
import { Typography } from '@material-ui/core'
import { VideocamOff } from '@material-ui/icons'
import { useTranslation } from 'react-i18next'

const PlayerContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 */
  background: #1b263b;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.06);
`

const StyledIframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
`

const NoStream = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.4);
`

function CameraPlayer({ embed }) {
  const { t } = useTranslation(['cameras_view'])
  const normalizedEmbed = typeof embed === 'string' ? embed.trim() : ''
  let isSelfEmbed = false

  if (normalizedEmbed && typeof window !== 'undefined') {
    try {
      const parsed = new URL(normalizedEmbed, window.location.origin)
      isSelfEmbed =
        parsed.origin === window.location.origin &&
        /^\/cameras(\/|$)/.test(parsed.pathname)
    } catch {
      isSelfEmbed = false
    }
  }

  if (!normalizedEmbed || isSelfEmbed) {
    return (
      <PlayerContainer>
        <NoStream>
          <VideocamOff style={{ fontSize: 64 }} />
          <Typography style={{ color: 'inherit' }}>
            {t('cameras_view:stream_unavailable')}
          </Typography>
        </NoStream>
      </PlayerContainer>
    )
  }

  return (
    <PlayerContainer>
      <StyledIframe
        title="camera-stream"
        src={normalizedEmbed}
        allow="autoplay; fullscreen"
        allowFullScreen
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-pointer-lock"
      />
    </PlayerContainer>
  )
}

export default CameraPlayer
